/*
 * Copyright (c) 2024. World Wide Generation Ltd
 */

import { InfoIcon } from '@g17eco/molecules/info-icon';

export const CustomDashboardInfoIcon = ({ text }: { text: string }) => {
  return text ? <InfoIcon light text={text} className='mr-1' /> : null;
};
